import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {filter, map} from 'rxjs/operators';

import {validateColor} from '../utils/validate-color';
import {NgStyle, AsyncPipe} from '@angular/common';

interface IDisplayStyle {
  'background-color': string;
}

@Component({
  selector: 'app-full-color-picker',
  templateUrl: './full-color-picker.component.html',
  styleUrls: ['./full-color-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgStyle, AsyncPipe]
})
export class FullColorPickerComponent implements OnChanges {
  @Input() value: string = null;

  @Output() picked: EventEmitter<string> = new EventEmitter<string>();
  @Output() changed: EventEmitter<string> = new EventEmitter<string>();
  @Output() valueChange = this.changed;

  public current: string = null;

  private _currentSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public style$: Observable<IDisplayStyle> = this._currentSubject.pipe(
    filter(validateColor),
    map(FullColorPickerComponent.convertToStyle)
  );

  static convertToStyle(color: string): IDisplayStyle {
    return {'background-color': color};
  }

  public colorChange(event): void {
    this.changed.emit(event.target.value);
    this._currentSubject.next(event.target.value);
  }

  public colorPicked(event): void {
    this.picked.emit(event.target.value);
    this._currentSubject.next(event.target.value);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.value?.currentValue) {
      this.current = validateColor(changes?.value?.currentValue)
        ? changes?.value?.currentValue
        : null;
      this._currentSubject.next(this.current);
    }
  }
}
